enum SmartLabel {
    Focus = "smart-label-focus",
    PourInfo = "smart-label-pour-info",
    Newsletter = "smart-label-newsletter",
    Suspect = "smart-label-suspect",
    Autre = "smart-label-autre",
    Traites = "smart-label-traites",
}

export const smartLabelColors = {
    [SmartLabel.Focus]: "#6f3fa8",
    [SmartLabel.PourInfo]: "#2e82d7",
    [SmartLabel.Newsletter]: "#4ac9ac",
    [SmartLabel.Suspect]: "#ca5f44",
    [SmartLabel.Autre]: "#b1a8b9",
    [SmartLabel.Traites]: "#16a34a",
};

export default SmartLabel;
